import { OnInit } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { TokenManager } from '../Globals';
var LayoutProfileDetailComponent = /** @class */ (function () {
    function LayoutProfileDetailComponent(route, router, globals, summaryService, tokenManager) {
        this.route = route;
        this.router = router;
        this.globals = globals;
        this.summaryService = summaryService;
        this.tokenManager = tokenManager;
        this.isProfile = true;
        this.searchKeyword = "";
        this.smallPad = false;
    }
    LayoutProfileDetailComponent.prototype.ngOnInit = function () {
        this.tokenManager.store("BRNCurrentRoute", this.router.url);
        if (this.globals.Session == null) {
            this.router.navigate(['/', '/']);
        }
        ;
        if (this.route.snapshot.paramMap.get('id')) {
            this.selectedDetailId = this.route.snapshot.paramMap.get('id');
        }
        // if(this.componentId && this.globals.Session){
        //   this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(result=>{
        //     if(result){
        //       this.searchKeyword = result;
        //     }else{
        //       this.searchKeyword = "";
        //     }
        //   })
        // }
    };
    LayoutProfileDetailComponent.prototype.toggleSidebar = function (showView) {
        if (showView) {
            this.smallPad = false;
        }
        else {
            this.smallPad = true;
        }
    };
    return LayoutProfileDetailComponent;
}());
export { LayoutProfileDetailComponent };
